module.exports = __webpack_public_path__ + "img/manager.c26b537e.svg";